import React from 'react';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { setCustomPrimary } from '@app/store/slices/themeSlice';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import './AppearancePicker.css';

const DEFAULT_COLOR = '#004c4c';

// Bộ màu preset (teal mặc định + các tông phổ biến)
const PRESETS: { name: string; color: string }[] = [
  { name: 'Teal (mặc định)', color: '#004c4c' },
  { name: 'Xanh dương', color: '#01509a' },
  { name: 'Indigo', color: '#4f46e5' },
  { name: 'Tím', color: '#7c3aed' },
  { name: 'Cyan', color: '#0891b2' },
  { name: 'Xanh lá', color: '#059669' },
  { name: 'Cam', color: '#ea580c' },
  { name: 'Hồng', color: '#e11d48' },
];

export const AppearancePicker: React.FC = () => {
  const dispatch = useAppDispatch();
  const customPrimary = useAppSelector((state) => state.theme.customPrimary);
  const current = (customPrimary || DEFAULT_COLOR).toLowerCase();

  const pick = (color: string) => dispatch(setCustomPrimary(color));
  const reset = () => dispatch(setCustomPrimary(''));

  return (
    <div className="appearance-picker">
      <div className="appearance-picker__swatches">
        {PRESETS.map((p) => (
          <button
            key={p.color}
            type="button"
            title={p.name}
            aria-label={p.name}
            className={`appearance-picker__swatch${current === p.color.toLowerCase() ? ' is-active' : ''}`}
            style={{ background: p.color }}
            onClick={() => pick(p.color)}
          />
        ))}
      </div>

      <label className="appearance-picker__custom">
        <span>Màu tuỳ chọn</span>
        <input type="color" value={customPrimary || DEFAULT_COLOR} onChange={(e) => pick(e.target.value)} />
      </label>

      <BaseButton size="small" block onClick={reset} disabled={!customPrimary}>
        Khôi phục mặc định
      </BaseButton>
    </div>
  );
};
